// DO NOT EDIT THIS FILE

import gql from 'graphql-tag';

export const ASSIGNE_ALL_VERTICAL = gql`
query assignAllVertical($search: String) {
  assignes: verticals(employees_User_FirstName_Icontains: $search) {
    edges {
      node {
        id
        employees(user_FirstName: $search, user_Status_Verified: true) {
          edges {
            node {
              id
              user {
                id
                firstName
                lastName
              }
            }
          }
        }
      }
    }
  }
}
`;
